// @flow
import React from 'react';
import { useViewport } from 'components/templates/viewportProvider';
import { withRouter } from 'react-router-dom';
import { JobPosts } from 'components/organisms/jobPosts';
import type { JobPost } from 'types/careers';
import { JobPostsMobile } from 'components/organisms/jobPostsMobile';
import { RouteUtil } from 'utils/RouteUtil';

type Props = {
  data: Array<JobPost>,
};

const JobPostsSection = (props: Props) => {
  const { isMobile } = useViewport();
  const { data, breadcrumbList } = props;
  if (!data || data.length === 0) {
    return null;
  }

  const goToCareerDetails = job => {
    const locationPath = props.location;
    RouteUtil.setRouteChange(
      props,
      checkUrlSlug(job),
      locationPath.hash,
      locationPath.pathname
    );
  };

  const checkUrlSlug = job_data => {
    if (job_data.urlSlug) return `/careers/${job_data.urlSlug}`;
    else return `/careers/${job_data}`;
  };

  return (
    <div id={'jobs'}>
      {isMobile ? (
        <JobPostsMobile
          jobPosts={data}
          onClick={goToCareerDetails}
          breadcrumbList={breadcrumbList}
        />
      ) : (
        <JobPosts jobPosts={data} onClick={goToCareerDetails} />
      )}
    </div>
  );
};

export default withRouter(JobPostsSection);
